import React from "react";
import styled from "styled-components";
import { bulletIcon } from "../../../../assets/icons";

export default function WhyDonateSection({ data }) {
	return (
		<section>
			<CardContainer>
				<div>
					<img src={bulletIcon} alt="bullet" />
				</div>
				<div className="details">
					<h4>Why you should Donate for us</h4>
					<p className="text-justify">
						We are a non-profit registered charity. Charity Registration Number: 794511469 RR0001. 
						Your generous support will go directly to providing
						support and assistance to our community’s most
						vulnerable including children, those living with a
						mental illness, victims of violence and the homeless.
						Help build our community and inspire hope today.
					</p>
				</div>
			</CardContainer>
		</section>
	);
}

const CardContainer = styled.div`
	img {
		width: 2rem;
		height: 14px;
	}

	.details {
		display: flex;
		flex-direction: column;

		h4 {
			width: 100%;
			font-weight: bold;
			margin-bottom: 0.9rem;
		}

		p {
			width: 100%;
			margin-bottom: 0 !important;
		}
	}

	@media (min-width: 720px) {
		img {
			width: 2rem;
			height: 14px;
		}

		.details {
			flex-direction: row;

			h4 {
				width: 22%;
				margin-right: 3rem;
			}

			p {
				width: 70%;
			}
		}
	}
`;
